import {
  type EpocusEncounter,
  RXDB_EPOCUS_ENCOUNTER_COLLECTION_NAME,
} from "$global-providers/rxdb-provider/collections/epocus-encounter";
import {
  type EpocusReview,
  RXDB_EPOCUS_REVIEW_COLLECTION_NAME,
} from "$global-providers/rxdb-provider/collections/epocus-review";
import { useRxData } from "rxdb-hooks";

const TODAY_MS = 24 * 60 * 60 * 1000;

export type HomeStats = {
  todayCount: number;
  pendingCount: number;
  totalCount: number;
  /** Formatted to 1 d.p. (e.g. "4.3"), or "—" when no reviews exist yet */
  avgQaScore: string;
};

export const useHomeStats = (): HomeStats => {
  const { result: encounters } = useRxData<EpocusEncounter>(
    RXDB_EPOCUS_ENCOUNTER_COLLECTION_NAME,
    (collection) => collection?.find(),
  );

  const { result: reviews } = useRxData<EpocusReview>(
    RXDB_EPOCUS_REVIEW_COLLECTION_NAME,
    (collection) => collection?.find(),
  );

  const todayCount = encounters.filter(
    (e) => Date.now() - new Date(e.date).getTime() < TODAY_MS,
  ).length;

  const pendingCount = encounters.filter(
    (e) => e.status === "pending_review",
  ).length;

  const totalCount = encounters.length;

  const avgQaScore =
    reviews.length > 0
      ? (
          reviews.reduce((sum, r) => sum + r.qualityScore, 0) / reviews.length
        ).toFixed(1)
      : "—";

  return { todayCount, pendingCount, totalCount, avgQaScore };
};
